import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Card, CardBody, CardFooter } from 'reactstrap';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import '../../css/components/Level/level.css';
import AxiosInstance from '../AxiosInstance/AxiosInstance';
import queryString from 'query-string';
import ListToTree from '../../common/listToTree/ListToTree';

class ScorecardMasterSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: [],
      latestChecked: [],
      Level: [],
      Levelnodes: []
    };

    this.onExpand = this.onExpand.bind(this);
    this.Redirect = this.Redirect.bind(this);

    this.SearchLevel();
  }

  onExpand(expanded) {
    this.setState({ expanded });
  }

  SearchLevel() {
    AxiosInstance({
      method: 'post',
      url: 'tbGEN_m_Level/usp_tbGEN_m_Level_SelectByDeptLevelWithAccessRights_V12',
      data: {
        dcKey: parseFloat(this.props.dcKey)
      }
    })
      .then(response => {
        if (response != undefined && response.data != undefined) {
          this.setState({
            Levelnodes: []
          })

          var SCLevel = [];
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].parentKey == 0) {
              SCLevel.push({
                key: response.data[i].key,
                parentKey: response.data[i].parentKey,
                isScoreCard: 0,
                label: response.data[i].name,
                value: '?Scorecard=0&key=' + response.data[i].key
                  + '&name=' + response.data[i].name,
                showCheckbox: false,
                icon: <span className="rct-icon rct-icon-parent-close" />
              })
            } else if (response.data[i].tbBCMmDepartmentID == 0) {
              SCLevel.push({
                key: response.data[i].key,
                parentKey: response.data[i].parentKey,
                isScoreCard: 0,
                label: response.data[i].name,
                value: '?Scorecard=0&key=' + response.data[i].key
                  + '&name=' + response.data[i].name,
                showCheckbox: false,
                icon: <span className="fa fa-folder-o" />
              })
            }
            else {
              SCLevel.push({
                key: response.data[i].key,
                parentKey: response.data[i].parentKey,
                isScoreCard: 1,
                label: response.data[i].name,
                value: {
                  Scorecard: 1, tbBCMmDepartmentID: response.data[i].tbBCMmDepartmentID, name: response.data[i].name,
                  readOnly: response.data[i].readOnly, writeOnly: response.data[i].writeOnly, deleteOnly: response.data[i].deleteOnly, reportOnly: response.data[i].reportOnly
                },
                showCheckbox: false,
                icon: <span className="fa fa-id-card-o" />
              })
            }
          }

          var tree = ListToTree.listToTree(SCLevel, {
            key_id: 'key',
            key_parent: 'parentKey',
          })

          var LvlTree = ListToTree.refit_keys(tree);

          var LvlTree_items = [];
          LvlTree_items = LvlTree.filter(function (Obj, key) {
            var Level1_Obj = Obj;
            if (Level1_Obj.hasOwnProperty("children")) {
              if (Level1_Obj.children.length > 0) {
                Level1_Obj.children = Level1_Obj.children.filter(function (Obj, key) {
                  var Level2_Obj = Obj;
                  if (Level2_Obj.hasOwnProperty("children")) {
                    if (Level2_Obj.children.length > 0) {
                      Level2_Obj.children = Level2_Obj.children.filter(function (Obj, key) {
                        var Level3_Obj = Obj;
                        if (Level3_Obj.hasOwnProperty("children")) {
                          if (Level3_Obj.children.length > 0) {
                            Level3_Obj.children = Level3_Obj.children.filter(function (Obj, key) {
                              var Level4_Obj = Obj;
                              if (Level4_Obj.hasOwnProperty("children")) {
                                if (Level4_Obj.children.length > 0) {
                                  Level4_Obj.children = Level4_Obj.children.filter(function (Obj, key) {
                                    var Level5_Obj = Obj;
                                    if (Level5_Obj.hasOwnProperty("children")) {
                                      if (Level5_Obj.children.length > 0) {
                                        Level5_Obj.children = Level5_Obj.children.filter(function (Obj, key) {
                                          var Level6_Obj = Obj;
                                          if (Level6_Obj.hasOwnProperty("children")) {
                                            if (Level6_Obj.children.length > 0) {
                                              Level6_Obj.children = Level6_Obj.children.filter(function (Obj, key) {
                                                var Level7_Obj = Obj;
                                                if (Level7_Obj.hasOwnProperty("children")) {
                                                  if (Level7_Obj.children.length > 0) {
                                                    Level7_Obj.children = Level7_Obj.children.filter(function (Obj, key) {
                                                      var Level8_Obj = Obj;
                                                      if (Level8_Obj.hasOwnProperty("children")) {
                                                        if (Level8_Obj.children.length > 0) {
                                                          Level8_Obj.children = Level8_Obj.children.filter(function (Obj, key) {
                                                            var Level9_Obj = Obj;
                                                            if (Level9_Obj.hasOwnProperty("children")) {
                                                              if (Level9_Obj.children.length > 0) {
                                                                Level9_Obj.children = Level9_Obj.children.filter(function (Obj, key) {
                                                                  var Level10_Obj = Obj;
                                                                  if (Level10_Obj.hasOwnProperty("children")) {
                                                                    if (Level10_Obj.children.length > 0) {
                                                                      Level10_Obj.children = Level10_Obj.children.filter(function (Obj, key) {
                                                                        var Level11_Obj = Obj;
                                                                        if (Level11_Obj.hasOwnProperty("children")) {
                                                                          if (Level11_Obj.children.length > 0) {
                                                                            Level11_Obj.children = Level11_Obj.children.filter(function (Obj, key) {
                                                                              var Level12_Obj = Obj;
                                                                              return Level12_Obj.filter((el) => el.isScoreCard == 1);
                                                                            });

                                                                            if (Level11_Obj.children.length > 0) {
                                                                              return Level11_Obj;
                                                                            } else {
                                                                              return null;
                                                                            }
                                                                          }
                                                                          else {
                                                                            if (Level11_Obj.isScoreCard == 1) {
                                                                              return Level11_Obj;
                                                                            }
                                                                            else {
                                                                              return null;
                                                                            }
                                                                          }
                                                                        }
                                                                        else {
                                                                          if (Level11_Obj.isScoreCard == 1) {
                                                                            return Level11_Obj;
                                                                          }
                                                                          else {
                                                                            return null;
                                                                          }
                                                                        }
                                                                      });

                                                                      if (Level10_Obj.children.length > 0) {
                                                                        return Level10_Obj;
                                                                      } else {
                                                                        return null;
                                                                      }
                                                                    }
                                                                    else {
                                                                      if (Level10_Obj.isScoreCard == 1) {
                                                                        return Level10_Obj;
                                                                      }
                                                                      else {
                                                                        return null;
                                                                      }
                                                                    }
                                                                  }
                                                                  else {
                                                                    if (Level10_Obj.isScoreCard == 1) {
                                                                      return Level10_Obj;
                                                                    }
                                                                    else {
                                                                      return null;
                                                                    }
                                                                  }
                                                                });

                                                                if (Level9_Obj.children.length > 0) {
                                                                  return Level9_Obj;
                                                                } else {
                                                                  return null;
                                                                }
                                                              }
                                                              else {
                                                                if (Level9_Obj.isScoreCard == 1) {
                                                                  return Level9_Obj;
                                                                }
                                                                else {
                                                                  return null;
                                                                }
                                                              }
                                                            }
                                                            else {
                                                              if (Level9_Obj.isScoreCard == 1) {
                                                                return Level9_Obj;
                                                              }
                                                              else {
                                                                return null;
                                                              }
                                                            }
                                                          });

                                                          if (Level8_Obj.children.length > 0) {
                                                            return Level8_Obj;
                                                          } else {
                                                            return null;
                                                          }
                                                        }
                                                        else {
                                                          if (Level8_Obj.isScoreCard == 1) {
                                                            return Level8_Obj;
                                                          }
                                                          else {
                                                            return null;
                                                          }
                                                        }
                                                      }
                                                      else {
                                                        if (Level8_Obj.isScoreCard == 1) {
                                                          return Level8_Obj;
                                                        }
                                                        else {
                                                          return null;
                                                        }
                                                      }
                                                    });

                                                    if (Level7_Obj.children.length > 0) {
                                                      return Level7_Obj;
                                                    } else {
                                                      return null;
                                                    }
                                                  }
                                                  else {
                                                    if (Level7_Obj.isScoreCard == 1) {
                                                      return Level7_Obj;
                                                    }
                                                    else {
                                                      return null;
                                                    }
                                                  }
                                                }
                                                else {
                                                  if (Level7_Obj.isScoreCard == 1) {
                                                    return Level7_Obj;
                                                  }
                                                  else {
                                                    return null;
                                                  }
                                                }
                                              });

                                              if (Level6_Obj.children.length > 0) {
                                                return Level6_Obj;
                                              } else {
                                                return null;
                                              }
                                            }
                                            else {
                                              if (Level6_Obj.isScoreCard == 1) {
                                                return Level6_Obj;
                                              }
                                              else {
                                                return null;
                                              }
                                            }
                                          }
                                          else {
                                            if (Level6_Obj.isScoreCard == 1) {
                                              return Level6_Obj;
                                            }
                                            else {
                                              return null;
                                            }
                                          }
                                        });

                                        if (Level5_Obj.children.length > 0) {
                                          return Level5_Obj;
                                        } else {
                                          return null;
                                        }
                                      }
                                      else {
                                        if (Level5_Obj.isScoreCard == 1) {
                                          return Level5_Obj;
                                        }
                                        else {
                                          return null;
                                        }
                                      }
                                    }
                                    else {
                                      if (Level5_Obj.isScoreCard == 1) {
                                        return Level5_Obj;
                                      }
                                      else {
                                        return null;
                                      }
                                    }
                                  });

                                  if (Level4_Obj.children.length > 0) {
                                    return Level4_Obj;
                                  } else {
                                    return null;
                                  }
                                }
                                else {
                                  if (Level4_Obj.isScoreCard == 1) {
                                    return Level4_Obj;
                                  }
                                  else {
                                    return null;
                                  }
                                }
                              }
                              else {
                                if (Level4_Obj.isScoreCard == 1) {
                                  return Level4_Obj;
                                }
                                else {
                                  return null;
                                }
                              }
                            });

                            if (Level3_Obj.children.length > 0) {
                              return Level3_Obj;
                            } else {
                              return null;
                            }
                          }
                          else {
                            if (Level3_Obj.isScoreCard == 1) {
                              return Level3_Obj;
                            }
                            else {
                              return null;
                            }
                          }
                        }
                        else {
                          if (Level3_Obj.isScoreCard == 1) {
                            return Level3_Obj;
                          }
                          else {
                            return null;
                          }
                        }
                      });

                      if (Level2_Obj.children.length > 0) {
                        return Level2_Obj;
                      } else {
                        return null;
                      }
                    }
                    else {
                      if (Level2_Obj.isScoreCard == 1) {
                        return Level2_Obj;
                      }
                      else {
                        return null;
                      }
                    }
                  }
                  else {
                    if (Level2_Obj.isScoreCard == 1) {
                      return Level2_Obj;
                    }
                    else {
                      return null;
                    }
                  }
                });

                if (Level1_Obj.children.length > 0) {
                  return Level1_Obj;
                } else {
                  return null;
                }
              }
              else {
                if (Level1_Obj.isScoreCard == 1) {
                  return Level1_Obj;
                }
                else {
                  return null;
                }
              }
            }
            else {
              if (Level1_Obj.isScoreCard == 1) {
                return Level1_Obj;
              }
              else {
                return null;
              }
            }
          });

          this.setState({
            Levelnodes: LvlTree_items
          })
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  }

  Redirect(data) {

    var val = data.value;
    // var params = queryString.parse(val);
    var dptID = '';
    var name = '';
    var readOnly = '';
    var writeOnly = '';
    var deleteOnly = '';
    var reportOnly = '';

    if (val.Scorecard == 1) {
      dptID = val.tbBCMmDepartmentID;
      name = val.name;
      readOnly = val.readOnly;
      writeOnly = val.writeOnly;
      deleteOnly = val.deleteOnly;
      reportOnly = val.reportOnly;

      sessionStorage.setItem('NewQRadar_tbBCMmDepartmentID', dptID);
      sessionStorage.setItem('NewQRadar_scoreCard', name);
      sessionStorage.setItem('NewQRadar_tbWFLtBCMTransactionID', -1);
      sessionStorage.setItem('NewQRadar_readOnly', readOnly);
      sessionStorage.setItem('NewQRadar_writeOnly', writeOnly);
      sessionStorage.setItem('NewQRadar_deleteOnly', deleteOnly);
      sessionStorage.setItem('NewQRadar_reportOnly', reportOnly);
      // var url = process.env.PUBLIC_URL + "/bcmuser/departmentinfo/departmentinfolist";
      // return window.location.hash = url;



      this.checkWorkFlow(dptID);
      //window.location.reload();   //reload once the session being set to access to the selected screen
      //  window.location.hash = "/bcmuser/departmentinfo/departmentinfolist";


    }

  }

  checkWorkFlow(dptID) {
    if (dptID != "") {
      AxiosInstance({
        method: 'POST',
        url: 'tbWFL_t_BCMTransaction/usp_tbWFL_t_BCMTransaction_SelectWFLStatusByDeptIDEx_V12',
        withCredentials: true,
        errorHandler: true,
        data: {
          dctbBCMmDepartmentID: dptID
        }
      })
        .then(response => {

          sessionStorage.setItem('NewQRadar_BCMDisableDepartment', response.data.disableScreen);

          if (window.location.hash === '#/bcmuser/scorecardmasterselection') {
            window.location.hash = "/bcmuser/departmentinfo/departmentinfolist";
          } else if (window.location.href.includes('?')) {
            window.history.go(-1);
          } else {
            window.location.reload();
          }

        })
        .catch(function (error) {

        });
    } else {

      if (window.location.hash === '#/bcmuser/scorecardmasterselection') {
        window.location.hash = "/bcmuser/departmentinfo/departmentinfolist";
      } else if (window.location.href.includes('?')) {
        window.history.go(-1);
      } else {
        window.location.reload();
      }
    }
  }



  render() {
    const { expanded, Levelnodes } = this.state;
    let ReactCheckboxTree;
    if (Levelnodes.length > 0) {
      ReactCheckboxTree =
        <Card className="selectionCard">
          <CardBody className="selectionCardBody">
            <CheckboxTree
              disabled
              expanded={expanded}
              nodes={Levelnodes}
              onExpand={this.onExpand}
              noCascade={true}
              showExpandAll
              onlyLeafCheckboxes={true}
              onClick={this.Redirect}
            />
          </CardBody>
        </Card>
    }

    return (
      <div >
        {ReactCheckboxTree}
      </div>
    )
  }
}

export default ScorecardMasterSelection;
